import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { Form, Modal, ModalBody } from "reactstrap";
import { Button, Col, Icon } from "../../../../components/Component";

const WeightModal = ({ modal, closeModal, onSubmit, formData, setFormData, filterStatus, type }) => {
  const {
    reset,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues: { lowerBound: "", upperBound: "", amount: "" } });

  //function to close modal
  const close = () => {
    closeModal();
  };
  // console.log(rolesOptions);

  useEffect(() => {
    reset(formData);
  }, [formData, reset]);

  return (
    <Modal isOpen={modal} toggle={() => close()} className="modal-dialog-centered" size="lg">
      <ModalBody>
        <a
          href="#cancel"
          onClick={(ev) => {
            ev.preventDefault();
            close();
          }}
          className="close"
        >
          <Icon name="cross-sm"></Icon>
        </a>
        <div className="p-2">
          <h5 className="title">{type.add ? "Add Zone" : "Edit Zone"}</h5>
          <div className="mt-4">
            <Form className="row gy-4" noValidate onSubmit={handleSubmit(onSubmit)}>
              <Col md="6">
                <div className="form-group">
                  <label className="form-label">Lowerbound (kg)</label>
                  <div className="form-control-wrap">
                    <input
                      className="form-control"
                      type="number"
                      {...register("lowerBound", { required: "This field is required" })}
                      defaultValue={formData.amount}
                      onChange={(e) => setFormData({ ...formData, lowerBound: e.target.value })}
                    />
                  </div>
                  {errors.lowerBound && <span className="invalid">{errors.lowerBound.message}</span>}
                </div>
              </Col>

              <Col md="6">
                <div className="form-group">
                  <label className="form-label">Upperbound (Kg)</label>
                  <div className="form-control-wrap">
                    <input
                      className="form-control"
                      type="number"
                      {...register("upperBound", { required: "This field is required" })}
                      defaultValue={formData.amount}
                      onChange={(e) => setFormData({ ...formData, upperBound: e.target.value })}
                    />
                  </div>
                  {errors.upperBound && <span className="invalid">{errors.upperBound.message}</span>}
                </div>
              </Col>

              <Col md="6">
                <div className="form-group">
                  <label className="form-label">Amount</label>
                  <input
                    className="form-control"
                    type="number"
                    {...register("amount", { required: "This field is required" })}
                    defaultValue={formData.amount}
                    onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
                  />

                  {errors.amount && <span className="invalid">{errors.amount.message}</span>}
                </div>
              </Col>
              <Col size="12">
                <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                  <li>
                    <Button color="primary" size="md" type="submit">
                      {type.add ? "Add Weight" : "Edit Weight"}
                    </Button>
                  </li>
                  <li>
                    <a
                      href="#cancel"
                      onClick={(ev) => {
                        ev.preventDefault();
                        close();
                      }}
                      className="link link-light"
                    >
                      Cancel
                    </a>
                  </li>
                </ul>
              </Col>
            </Form>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};
export default WeightModal;
